module.exports = __webpack_public_path__ + "static/img/17-2.6c53e28.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/17-2.jpg
// module id = xgEv
// module chunks = 0